<template>
  <div
    v-if="links"
    v-editable="links"
    :class="{ 'mt-4': hasMarginTop, 'w-full': fullWidth }"
    class="flex gap-2 overflow-y-auto scrollbar-hide sm:justify-center"
  >
    <Intersect
      v-for="link in links"
      :key="link._uid"
      :threshold="0.5"
      @enter.once="handleVisibility(link, $route)"
    >
      <NuxtLink
        event=""
        :to="toLocalePath(link.cta_url?.cached_url || '')"
        class="text-base font-normal leading-5 text-white underline"
        data-test-id="scrollable-link"
        @click="clickObserver(link, $route)"
      >
        {{ link.label }}
      </NuxtLink>
    </Intersect>
  </div>
</template>

<script setup lang="ts">
import { getAllCategoryPaths } from '~/utils/category'
import useRouteHelpers from '~/composables/useRouteHelpers'
import { useRouter } from '#app/composables/router'
import useTrackingEvents from '~/composables/tracking/useTrackingEvents'
import { getPageCategoryForTracking } from '~/utils/tracking'
import useRootCategories from '~/composables/useRootCategories'
import type { SbBannerLink } from '~/cms/storyblok/types/storyblok.d.ts'
import type { RouteLocation, RouteLocationNormalized } from '#vue-router'

defineProps<{
  links?: SbBannerLink[]
  hasMarginTop?: boolean
  fullWidth?: boolean
}>()

const emit = defineEmits<{
  'view:promotion-intercept': [{ clickPathCategory: string; url: string }]
  'click:promotion-click': [{ clickPathCategory: string; url: string }]
}>()

const { trackPromotion } = useTrackingEvents()
const router = useRouter()
const { toLocalePath } = useRouteHelpers()
const { data: rootCategories } = useRootCategories()

const handleVisibility = (
  link: SbBannerLink,
  route: RouteLocationNormalized,
) => {
  const url = toLocalePath(link.cta_url?.cached_url || '')
  emit('view:promotion-intercept', {
    clickPathCategory: getPageCategoryForTracking(
      route,
      getAllCategoryPaths(rootCategories.value?.categories ?? []),
    ),
    url,
  })
  if (link.promotion_id) {
    trackPromotion('view_promotion', link, { url: url.toString() })
  }
}
const clickObserver = (link: SbBannerLink, route: RouteLocation) => {
  const url = toLocalePath(link.cta_url?.cached_url || '')
  emit('click:promotion-click', {
    clickPathCategory: getPageCategoryForTracking(
      route,
      getAllCategoryPaths(rootCategories.value?.categories ?? []),
    ),
    url,
  })

  router.push(toLocalePath(link.cta_url?.cached_url || ''))
  if (link.promotion_id) {
    trackPromotion('select_promotion', link, { url: url.toString() })
  }
}
</script>
